

































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ApplicationLayoutFluid from "@/layouts/ApplicationLayoutFluid.vue";
import GroupOrder from "@/views/business-rules/partials/GroupOrder.vue";
import RuleEditor from "@/views/business-rules/partials/RuleEditor.vue";
import BusinessRulesModule from "@/store/modules/business-rules";

const businessRules = namespace(BusinessRulesModule.name);

@Component({
  name: "BusinessRulesIndex",
  components: {
    ApplicationLayoutFluid,
    GroupOrder,
    RuleEditor
  }
})
export default class BusinessRulesIndex extends Vue {
  // ===== Store ===== //
  @businessRules.Action("getAllGroups") public getAllGroups!: () => void;
  @businessRules.Action("getAllMetrics") public getAllMetrics!: () => void;
  @businessRules.Action("handleResetBusinessRules")
  public handleResetBusinessRules!: () => void;

  // ===== Data ===== //

  // ===== Methods ===== //

  // ===== Computed ===== //

  // ===== Lifecycle Hooks ===== //
  private created(): void {
    this.getAllGroups();
    this.getAllMetrics();
  }
  private beforeDestroy(): void {
    this.handleResetBusinessRules();
  }
}
